var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcLivreW(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37.26 37.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_358",
    "data-name": "Groupe 358"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_294",
    "data-name": "Groupe 294"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3948",
    "data-name": "Trac\\xE9 3948",
    d: "M36.67,24.45a.58.58,0,0,1-.58-.58h0V5.24a.58.58,0,0,0-.58-.58.59.59,0,0,1-.59-.58.6.6,0,0,1,.58-.59h0a1.76,1.76,0,0,1,1.74,1.75V23.87A.58.58,0,0,1,36.67,24.45Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_295",
    "data-name": "Groupe 295"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3949",
    "data-name": "Trac\\xE9 3949",
    d: "M20.37,29.11H16.88a1.79,1.79,0,0,1-1.74-1.69s0,0,0-.06H1.75A1.74,1.74,0,0,1,0,25.62V5.24A1.76,1.76,0,0,1,1.75,3.49a.59.59,0,0,1,0,1.17.58.58,0,0,0-.59.58V25.62a.58.58,0,0,0,.59.58H15.14a1.14,1.14,0,0,1,1.16,1.1.63.63,0,0,0,.58.64h3.49A.64.64,0,0,0,21,27.3a1.14,1.14,0,0,1,1.16-1.1h1.75a.57.57,0,0,1,.57.59.59.59,0,0,1-.57.58H22.13a.07.07,0,0,0,0,.05A1.8,1.8,0,0,1,20.37,29.11Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_296",
    "data-name": "Groupe 296"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3950",
    "data-name": "Trac\\xE9 3950",
    d: "M18.63,25.62a.6.6,0,0,1-.48-.24c-.27-.39-1.56-1.32-7.47-1.55-3.35-.13-6.54,0-6.58,0a.58.58,0,0,1-.61-.55V.58A.58.58,0,0,1,4.07,0h0S7.5,0,11,.29c6.57.55,7.81,1.62,8.17,2.37a.54.54,0,0,1,.06.25V25a.58.58,0,0,1-.58.58Zm-10.69-3c.87,0,1.82,0,2.78.05,4.24.16,6.3.7,7.33,1.19V3.08c-.26-.31-1.48-1.16-7.16-1.63-2.59-.21-5.12-.27-6.23-.28V22.68c.68,0,1.87-.06,3.28-.06Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_297",
    "data-name": "Groupe 297"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3951",
    "data-name": "Trac\\xE9 3951",
    d: "M18.63,25.62a.58.58,0,0,1-.58-.58h0V2.91a.43.43,0,0,1,.05-.25C18.46,1.9,19.7.84,26.27.29,29.76,0,33.15,0,33.18,0a.58.58,0,0,1,.58.58h0V15.72a.58.58,0,0,1-1.16,0h0V1.17c-1.11,0-3.65.07-6.24.28-5.67.48-6.9,1.32-7.15,1.63V23.87a12.85,12.85,0,0,1,4-1,.58.58,0,0,1,.64.51.58.58,0,0,1-.51.65c-3.26.38-4.06,1-4.25,1.31A.59.59,0,0,1,18.63,25.62Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_298",
    "data-name": "Groupe 298"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3952",
    "data-name": "Trac\\xE9 3952",
    d: "M28,25.79a.58.58,0,0,1-.54-.38l-2.93-7.74a.52.52,0,0,1,0-.21V12.23a.58.58,0,0,1,1-.42l3.82,3.74a.52.52,0,0,1,.14.19h0l3.13,7.56a.57.57,0,0,1-.31.76l-4,1.67A.59.59,0,0,1,28,25.79Zm-2.35-8.43,2.69,7.08,2.94-1.22-2.7-6.5-1,.38a.57.57,0,0,1-.75-.33.59.59,0,0,1,.33-.76l.66-.25-2.2-2.15Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_299",
    "data-name": "Groupe 299"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3953",
    "data-name": "Trac\\xE9 3953",
    d: "M34,37.26a3.3,3.3,0,0,1-3.06-2l-4-9.58a.59.59,0,0,1,.32-.76l5-2.08a.57.57,0,0,1,.76.31h0l4,9.58A3.32,3.32,0,0,1,35.21,37h0A3.22,3.22,0,0,1,34,37.26ZM28.22,25.74l3.74,9a2.16,2.16,0,0,0,2.8,1.17h0a2.17,2.17,0,0,0,1.17-2.8l-3.75-9Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_300",
    "data-name": "Groupe 300"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3954",
    "data-name": "Trac\\xE9 3954",
    d: "M33.64,34.1a.59.59,0,0,1-.54-.37l-2.33-5.82a.59.59,0,0,1,.33-.76.58.58,0,0,1,.75.33l2.33,5.82a.57.57,0,0,1-.32.75A.54.54,0,0,1,33.64,34.1Z",
    style: {
      fill: "#fff"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLivreW);
export default __webpack_public_path__ + "static/media/ic-livre-w.54bac14ce197eadab40c542f0ba84e91.svg";
export { ForwardRef as ReactComponent };